import { IJsonQuery } from '@cian/api-models/common/json_query';
import * as React from 'react';

import { TModifier } from '../types/modifier';
import { ISpecialPromo } from '../types/specialPromo';

export interface IContext {
  jsonQuery: IJsonQuery;
  specialPromo?: ISpecialPromo;
  onChange(...modifiers: [TModifier, ...TModifier[]]): void;
  onApply(): void;
  onClear?(): void;
  onApplyClick?(): void;
  onAdvancedFiltersOpen?(): void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const context = React.createContext<IContext>(null as any);
